import './index.css';

import { fetcher } from './app/shared/api/fetcher';
import { AppConfig } from './app/shared/models';
import { bootstrapApp } from './bootstrap.util';

fetcher<AppConfig>(process.env.REACT_APP_CONFIG_URL!)
  .json()
  .then(({ data }) => bootstrapApp(data))
  .catch((err) => {
    document.getElementById('root')!.innerHTML = `
      <p>Cannot load application configuration</p>
    `;
    console.error(
      'Cannot load application configuration from ',
      process.env.REACT_APP_CONFIG_URL,
      err
    );
  });
